import React from 'react';

export const ValidusLogo = ({ className = "w-10 h-10" }: { className?: string }) => (
  <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <defs>
      <linearGradient id="vGradLeft" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#60a5fa" /> {/* blue-400 */}
        <stop offset="100%" stopColor="#3b82f6" /> {/* blue-500 */}
      </linearGradient>
      
      <linearGradient id="vGradRight" x1="0%" y1="100%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#818cf8" /> {/* indigo-400 */}
        <stop offset="100%" stopColor="#4f46e5" /> {/* indigo-600 */}
      </linearGradient>

      <linearGradient id="vGradCenter" x1="50%" y1="0%" x2="50%" y2="100%">
        <stop offset="0%" stopColor="#22d3ee" /> {/* cyan-400 */}
        <stop offset="100%" stopColor="#0284c7" /> {/* sky-600 */}
      </linearGradient>

      <filter id="vGlow" x="-20%" y="-20%" width="140%" height="140%">
        <feGaussianBlur stdDeviation="4" result="blur" />
        <feComposite in="SourceGraphic" in2="blur" operator="over" />
      </filter>
    </defs>
    
    <g filter="url(#vGlow)">
      {/* Left Wing */}
      <path d="M15 20 L45 80 L55 80 L25 20 Z" fill="url(#vGradLeft)" />
      
      {/* Right Wing */}
      <path d="M85 20 L55 80 L45 80 L75 20 Z" fill="url(#vGradRight)" />
      
      {/* Core / Cyber Detail */}
      <path d="M50 65 L35 35 L45 35 L50 45 L55 35 L65 35 Z" fill="url(#vGradCenter)" opacity="0.9" />
    </g>
  </svg>
);
